<p>registration-modal works!</p>